import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import {v4 as uuidv4} from 'uuid';
import { getCyberSource } from '../../../redux/actions';
import { routes } from '../../../redux/api/routes';
let { cyberSourceRedirectURL } = routes;

class PayByCreditCard extends Component {

    constructor(props) {
        super(props);
		var transaction_uuidf = uuidv4,
			date = new Date(),
			signed_date_time = date.toISOString();
		signed_date_time = signed_date_time.substring(0, signed_date_time.indexOf('.'));
		signed_date_time += 'Z';
        this.state = {
			payload: {
				//Hard coded Values
				profile_id: "EC265CDE-05C0-42CB-9A14-8E9607E01A00",
				access_key: "cf7edfceaed532d4ad96341d4bf4bb40",
				transaction_uuid: transaction_uuidf(),
				signed_field_names: "access_key,profile_id,transaction_uuid,signed_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,override_custom_receipt_page,payment_method,bill_to_forename,bill_to_surname,bill_to_middleinitial,bill_to_address_line1,bill_to_address_line2,bill_to_address_city,bill_to_address_state,bill_to_address_country,bill_to_address_postal_code,bill_to_email,bill_to_company_name",
				locale: "en",
				transaction_type: "create_payment_token",
				currency: "USD",
				signed_date_time: signed_date_time,
				reference_number: new Date().getTime(),
				bill_to_address_country: "US",
				override_custom_receipt_page: cyberSourceRedirectURL,

				//Dynamic Values
				amount: '',
				payment_method: 'card',

				bill_to_email: '',
				bill_to_forename: '',
				bill_to_middleinitial: '',
	            bill_to_surname: '',
				bill_to_company_name: '',
	            bill_to_address_line1: '',
	            bill_to_address_line2: '',
	            bill_to_address_city: '',
	            bill_to_address_postal_code: '',
	            bill_to_address_state: ''
			},
			error: {
	            bill_to_forename_error: '',
	            bill_to_surname_error: '',
	            bill_to_address_line1_error: '',
	            bill_to_address_city_error: '',
				bill_to_address_state_error: '',
	            bill_to_address_postal_code_error: ''
			},
			errorMessage: '',
			CYBERSOURCE_URL: 'https://testsecureacceptance.cybersource.com/embedded/token/create'
        }
    }

	filterNumbers(event) {
		if(!(event.charCode >= 48 && event.charCode <= 57)){
            event.preventDefault();
        }
	}

	formatNumber2Decimal(number) {
        number = (number)?number.trim().replace(/,/g,""):number;
        if(number) {
            number = number.replace("$","");
            number = "$"+parseFloat(number).toFixed(2);
            return number === "$0.00"?"--":number;
        } else {
            return "--";
        }
    }

	componentWillMount() {
		window.scrollTo(0, 0);
		const self = this;
		const { order: { createOrderPayload } } = self.props.state;
		if(createOrderPayload && createOrderPayload.orderTotal) {
			const {
				user: {
					userDetails: {
						email,
						firstName,
						lastName,
					}
				}
			} = self.props.state;
			const { billingAddress } = createOrderPayload;
			self.setState({
				payload: {
					...this.state.payload,
					amount: parseFloat(createOrderPayload.orderTotal).toFixed(2),
					bill_to_email: email,
					bill_to_forename: firstName,
					bill_to_middleinitial: '',
					bill_to_surname: lastName,
					bill_to_address_line1: billingAddress.address1,
					bill_to_address_line2: billingAddress.address2,
					bill_to_address_city: billingAddress.city,
					bill_to_address_state: billingAddress.state,
					bill_to_address_postal_code: billingAddress.zip,
				}
			});
		} else {
			browserHistory.push('/cart');
		}
	}

	componentDidMount() {
		const self = this;
		const {
			payload: {
				amount,
				bill_to_address_postal_code,
				transaction_uuid,
				signed_field_names,
				locale,
				transaction_type,
				bill_to_email,
				bill_to_address_country,
				bill_to_surname,
				bill_to_middleinitial,
				bill_to_address_line2,
				bill_to_address_line1,
				profile_id,
				access_key,
				bill_to_address_city,
				currency,
				bill_to_forename,
				signed_date_time,
				payment_method,
				override_custom_receipt_page,
				reference_number,
			}
		} = self.state;
		self.props.getCyberSource("amount="+amount+"&bill_to_address_postal_code="+bill_to_address_postal_code+"&bill_to_company_name="+this.state.payload.bill_to_company_name+"&bill_to_address_state="+this.state.payload.bill_to_address_state+"&transaction_uuid="+transaction_uuid
			+"&signed_field_names="+signed_field_names+"&locale="+locale+"&transaction_type="+transaction_type+"&bill_to_email="+bill_to_email+"&bill_to_address_country="+bill_to_address_country+"&bill_to_surname="+bill_to_surname+"&bill_to_middleinitial="+bill_to_middleinitial
			+"&bill_to_address_line2="+bill_to_address_line2+"&bill_to_address_line1="+bill_to_address_line1+"&profile_id="+profile_id+"&access_key="+access_key+"&bill_to_address_city="+bill_to_address_city+"&currency="+currency+"&bill_to_forename="+bill_to_forename+"&signed_date_time="+signed_date_time
			+"&payment_method="+payment_method+"&override_custom_receipt_page="+override_custom_receipt_page+"&reference_number="+reference_number+"&secret_key=e4efc1332a6c41e78704a4d983ec2f05ea60fb01b6084ade99d75be799913739cd71857667bd4807954d511f62c18fda009f677d8d494f22919c3ad658a24694523a444ad3e747bea272712623be09c50acfb5fba4a4461f8e77286c41b370fc2a256609f9584f1e975930587b447c479187b2a6cc7b4ec5b36b60944e6a7728", response => {
			if(response.status) {
				self.setState({
					payload: {
						...self.state.payload,
						signature: response.responseObject.signature,
						access_key: response.responseObject.access_key,
						profile_id: response.responseObject.profile_id,
						transaction_uuid: response.responseObject.transaction_uuid,
						signed_field_names: response.responseObject.signed_field_names,
						signed_date_time: response.responseObject.signed_date_time,
						locale: response.responseObject.locale,
						transaction_type: response.responseObject.transaction_type,
						reference_number: response.responseObject.reference_number,
						payment_method: response.responseObject.payment_method,
						bill_to_address_country: response.responseObject.bill_to_address_country
					}
				}, () => {
					document.payment_confirmation.accessKey = response.responseObject.access_key;
					document.payment_confirmation.action = self.state.CYBERSOURCE_URL;
					document.payment_confirmation.target ="_self";
					document.payment_confirmation.submit();
				});
			} else if(response.error || !response.status) { //In case error occured or status is false
				//We customize code for error handling
				self.setState({
					errorMessage: response.responseMessage
				});
			}
		});
	}

	handleParamChange(event) {
		var self = this;
		self.setState({
			payload: {
				...self.state.payload,
				[event.target.name]: event.target.value
			}
		})

		if(self.state.error[event.target.name+"_error"]) {
			self.setState({
				error: {
					...self.state.error,
					[event.target.name+"_error"]: ""
				}
	        });
		}
	}

    acceptsOnlyNumbers(event) {
        if(event.charCode < 48 || event.charCode > 57) {
            event.preventDefault();
        }
    }

    handlePayByCreditCard(event){
        event.preventDefault();
		var self = this,
			params = self.state.payload,
			error = self.state.error,
			formError = false;

		//Reset all errors
		for(var key in error) {
            if(params[key.replace("_error","")] === "") {
                error[key] = 'error';
                formError = true;
            } else {
				error[key] = '';
			}
        }

		if(params.bill_to_address_postal_code.length !== 5) {
			formError = true;
			self.setState({
				error: {
					...self.state.error,
					bill_to_address_postal_code_error: 'error'
				}
			})
		}

		self.setState({
			errorMessage: ''
		})

        if(!formError && self.state.payload.amount && self.state.payload.amount !== '') {
            self.props.getCyberSource("amount="+this.state.payload.amount+"&bill_to_address_postal_code="+this.state.payload.bill_to_address_postal_code+"&bill_to_company_name="+this.state.payload.bill_to_company_name+"&bill_to_address_state="+this.state.payload.bill_to_address_state+"&transaction_uuid="+this.state.payload.transaction_uuid
                +"&signed_field_names="+this.state.payload.signed_field_names+"&locale="+this.state.payload.locale+"&transaction_type="+this.state.payload.transaction_type+"&bill_to_email="+this.state.payload.bill_to_email+"&bill_to_address_country="+this.state.payload.bill_to_address_country+"&bill_to_surname="+this.state.payload.bill_to_surname+"&bill_to_middleinitial="+this.state.payload.bill_to_middleinitial
                +"&bill_to_address_line2="+this.state.payload.bill_to_address_line2+"&bill_to_address_line1="+this.state.payload.bill_to_address_line1+"&profile_id="+this.state.payload.profile_id+"&access_key="+this.state.payload.access_key+"&bill_to_address_city="+this.state.payload.bill_to_address_city+"&currency="+this.state.payload.currency+"&bill_to_forename="+this.state.payload.bill_to_forename+"&signed_date_time="+this.state.payload.signed_date_time
                +"&payment_method="+this.state.payload.payment_method+"&override_custom_receipt_page="+this.state.payload.override_custom_receipt_page+"&reference_number="+this.state.payload.reference_number+"&secret_key=e4efc1332a6c41e78704a4d983ec2f05ea60fb01b6084ade99d75be799913739cd71857667bd4807954d511f62c18fda009f677d8d494f22919c3ad658a24694523a444ad3e747bea272712623be09c50acfb5fba4a4461f8e77286c41b370fc2a256609f9584f1e975930587b447c479187b2a6cc7b4ec5b36b60944e6a7728", response => {
				if(response.status) {
	                self.setState({
						payload: {
							...self.state.payload,
							signature: response.responseObject.signature,
		                    access_key: response.responseObject.access_key,
		                    profile_id: response.responseObject.profile_id,
		                    transaction_uuid: response.responseObject.transaction_uuid,
		                    signed_field_names: response.responseObject.signed_field_names,
		                    signed_date_time: response.responseObject.signed_date_time,
		                    locale: response.responseObject.locale,
		                    transaction_type: response.responseObject.transaction_type,
		                    reference_number: response.responseObject.reference_number,
		                    payment_method: response.responseObject.payment_method,
		                    bill_to_address_country: response.responseObject.bill_to_address_country
						}
	                }, () => {
						document.payment_confirmation.accessKey = response.responseObject.access_key;
		                document.payment_confirmation.action = self.state.CYBERSOURCE_URL;
		                document.payment_confirmation.target ="_self";
		                document.payment_confirmation.submit();
					});
				} else if(response.error || !response.status) { //In case error occured or status is false
					//We customize code for error handling
					self.setState({
						errorMessage: response.responseMessage
					});
				}
            });
        }
    }

    render() {
		const { user } = this.props.state;
		const { selectedAccount } = user;
        return (
            <div>
               	<div className="push hide">
					{/* NOTE: use only *one* of these two supplemental CSS classes:     */}
					{/*   loggedIn    - obviously, for when a user is logged in         */}
					{/*   notLoggedIn - obviously, for when a user is *not* logged in   */}
                    <div className="masthead loggedIn">
                    	<div className="clear">{/* DO NOT REMOVE */}</div>
					</div> {/* / .masthead */}
					<h1 className="Page Title">Pay By Credit Card</h1>
               	</div>
               	<div className="hide">
					<h3>Account # {selectedAccount && selectedAccount.ACCOUNTNUMBER} - {selectedAccount && selectedAccount.ACCOUNTDESCRIPTION}</h3>
					<p>I agree to pay GE Appliances a sum of {this.formatNumber2Decimal(this.state.payload.amount.toString())}. This sum includes applicable delivery and sales tax. Please use my credit card for payment.</p>
					<p className="importantText">*required fields</p>
					<p className="bold red">{this.state.errorMessage}</p>
                 	<form action="" onSubmit={(e) => { e.preventDefault() }}>
                       	<table className="spacedFormTable" style={{align:"center", width:"90%"}}>
							<tbody>
								<tr>
									<td className="label">
										<span className="importantText">*</span><strong>First Name<br />on card:</strong>
									</td>
									<td colSpan={2}>
										<input type="text" defaultValue={this.state.payload.bill_to_forename} name="bill_to_forename" onChange={this.handleParamChange.bind(this)} className={"fullWidthTextBlank " + (this.state.error.bill_to_forename_error)} />
									</td>
									<td className="label">
										<strong>Middle<br />Initial:</strong>
									</td>
									<td colSpan={3}>
										<input type="text" defaultValue={this.state.payload.bill_to_middleinitial} name="bill_to_middleinitial" onChange={this.handleParamChange.bind(this)}/>
									</td>
								</tr>
								<tr>
									<td className="label">
										<span className="importantText">*</span><strong>Last Name<br />on card:</strong>
										</td>
									<td colSpan={2}>
										<input type="text" defaultValue={this.state.payload.bill_to_surname} name="bill_to_surname" onChange={this.handleParamChange.bind(this)} className={"fullWidthTextBlank " + (this.state.error.bill_to_surname_error)}/>
									</td>
									<td className="label">
										<strong>Company Name<br />on card:</strong>
									</td>
									<td colSpan={3}>
										<input type="text" defaultValue={this.state.payload.bill_to_company_name} name="bill_to_company_name" onChange={this.handleParamChange.bind(this)} className="fullWidthTextBlank" />
									</td>
								</tr>
								<tr>
									<td className="label">
										<span className="importantText">*</span><strong>Billing Address<br />Line 1:</strong>
									</td>
									<td colSpan={6}>
										<input type="text" defaultValue={this.state.payload.bill_to_address_line1} name="bill_to_address_line1" onChange={this.handleParamChange.bind(this)} className={"fullWidthTextBlank " + (this.state.error.bill_to_address_line1_error)} />
									</td>
								</tr>
								<tr>
									<td className="label">
										<strong>Billing Address<br />Line 2:</strong>
									</td>
									<td colSpan={6}>
										<input type="text" defaultValue={this.state.payload.bill_to_address_line2} name="bill_to_address_line2" className="fullWidthTextBlank" onChange={this.handleParamChange.bind(this)} />
									</td>
								</tr>
								<tr>
									<td className="label">
										<span className="importantText">*</span><strong>City:</strong>
									</td>
									<td colSpan={2}>
										<input type="text" defaultValue={this.state.payload.bill_to_address_city} name="bill_to_address_city" onChange={this.handleParamChange.bind(this)} className={this.state.error.bill_to_address_city_error}/>
									</td>
									<td className="label">
										<span className="importantText">*</span><strong>State:</strong>
									</td>
									<td>
										<select defaultValue={this.state.payload.bill_to_address_state} name="bill_to_address_state" onChange={this.handleParamChange.bind(this)} className={this.state.error.bill_to_address_state_error}>
											<option value="">Select…</option>
											<option value="AL">Alabama</option>
											<option value="AK">Alaska</option>
											<option value="AZ">Arizona</option>
											<option value="AR">Arkansas</option>
											<option value="CA">California</option>
											<option value="CO">Colorado</option>
											<option value="CT">Connecticut</option>
											<option value="DE">Delaware</option>
											<option value="FL">Florida</option>
											<option value="GA">Georgia</option>
											<option value="HI">Hawaii</option>
											<option value="ID">Idaho</option>
											<option value="IL">Illinois</option>
											<option value="IN">Indiana</option>
											<option value="IA">Iowa</option>
											<option value="KS">Kansas</option>
											<option value="KY">Kentucky</option>
											<option value="LA">Louisiana</option>
											<option value="ME">Maine</option>
											<option value="MD">Maryland</option>
											<option value="MA">Massachusetts</option>
											<option value="MI">Michigan</option>
											<option value="MN">Minnesota</option>
											<option value="MS">Mississippi</option>
											<option value="MO">Missouri</option>
											<option value="MT">Montana</option>
											<option value="NE">Nebraska</option>
											<option value="NV">Nevada</option>
											<option value="NH">New Hampshire</option>
											<option value="NJ">New Jersey</option>
											<option value="NM">New Mexico</option>
											<option value="NY">New York</option>
											<option value="NC">North Carolina</option>
											<option value="ND">North Dakota</option>
											<option value="OH">Ohio</option>
											<option value="OK">Oklahoma</option>
											<option value="OR">Oregon</option>
											<option value="PA">Pennsylvania</option>
											<option value="RI">Rhode Island</option>
											<option value="SC">South Carolina</option>
											<option value="SD">South Dakota</option>
											<option value="TN">Tennessee</option>
											<option value="TX">Texas</option>
											<option value="UT">Utah</option>
											<option value="VT">Vermont</option>
											<option value="VA">Virginia</option>
											<option value="WA">Washington</option>
											<option value="WV">West Virginia</option>
											<option value="WI">Wisconsin</option>
											<option value="WY">Wyoming</option>
											<option value="DC">District of Columbia</option>
										</select>
									</td>
									<td className="label">
										<span className="importantText">*</span><strong>Zip:</strong>
									</td>
									<td>
										<input type="text" onKeyPress={this.filterNumbers} defaultValue={this.state.payload.bill_to_address_postal_code} maxLength={5} name="bill_to_address_postal_code" onChange={this.handleParamChange.bind(this)} className={this.state.error.bill_to_address_postal_code_error}/>
									</td>
								</tr>
								<tr>
									<td colSpan={7} style={{textAlign: 'right'}}>
										<a className="blueButton" href="" target="" onClick={this.handlePayByCreditCard.bind(this)}>Pay by Credit Card and confirm release</a>
									</td>
								</tr>
							</tbody>
						</table>
					</form>
				</div>
               	<form id="payment_confirmation" name="payment_confirmation" method="post">
					<input type="hidden" id="signature" name="signature" value={this.state.payload.signature}/>
				    <input type="hidden" name="access_key" value={this.state.payload.access_key}/>
		            <input type="hidden" name="profile_id" value={this.state.payload.profile_id}/>

		            <input type="hidden" id="transaction_uuid" name="transaction_uuid" value={this.state.payload.transaction_uuid} />
		            <input type="hidden" id="signed_field_names" name="signed_field_names" value={this.state.payload.signed_field_names}/>

		    	    <input type="hidden" id="signed_date_time" name="signed_date_time" value={this.state.payload.signed_date_time} />
				 	<input type="hidden" id="locale" name="locale" value={this.state.payload.locale}/>
			 		<input type="hidden" id="transaction_type" name="transaction_type" value={this.state.payload.transaction_type} />
					<input type="hidden" id="reference_number" name="reference_number" value={this.state.payload.reference_number} />
  				 	<input type="hidden" id="amount" name="amount" value={this.state.payload.amount} />
					<input type="hidden" id="currency" name="currency"  value={this.state.payload.currency}/>
					<input type="hidden" id="payment_method" name="payment_method" value={this.state.payload.payment_method} />
					<input type="hidden" id="bill_to_forename" name="bill_to_forename" value={this.state.payload.bill_to_forename} />
					<input type="hidden" id="bill_to_surname" name="bill_to_surname" value={this.state.payload.bill_to_surname} />
					<input type="hidden" id="bill_to_middleinitial" name="bill_to_middleinitial" value={this.state.payload.bill_to_middleinitial}/>
					<input type="hidden" id="bill_to_email" name="bill_to_email" value={this.state.payload.bill_to_email}/>
					<input type="hidden" id="bill_to_address_line1" name="bill_to_address_line1" value={this.state.payload.bill_to_address_line1}/>
					<input type="hidden" id="bill_to_address_line2" name="bill_to_address_line2" value={this.state.payload.bill_to_address_line2}/>
					<input type="hidden" id="bill_to_address_city" name="bill_to_address_city" value={this.state.payload.bill_to_address_city}/>
					<input type="hidden" id="bill_to_address_state" name="bill_to_address_state" value={this.state.payload.bill_to_address_state}/>
					<input type="hidden" id="bill_to_address_country" name="bill_to_address_country" value={this.state.payload.bill_to_address_country}/>
					<input type="hidden" id="bill_to_address_postal_code" name="bill_to_address_postal_code" value={this.state.payload.bill_to_address_postal_code}/>
					<input type="hidden" id="bill_to_company_name" name="bill_to_company_name" value={this.state.payload.bill_to_company_name}/>
					<input type="hidden" id="override_custom_receipt_page" name="override_custom_receipt_page" value={this.state.payload.override_custom_receipt_page} />
				</form>
			</div>
        );
    }
}
const mapStateToProps = (state) => {
    return { state };
};

const mapDispatchToProps = (dispatch) => ({
	getCyberSource: (queryString, callback) => dispatch(getCyberSource(queryString, callback))
})

PayByCreditCard = connect(mapStateToProps, mapDispatchToProps)(PayByCreditCard);
export default PayByCreditCard;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/payByCreditCard.js